<template>
    <base-content>
        <template v-slot:sub-header>
            &nbsp;
        </template>
        <template v-slot:content>
            <span class="display-1">Whoops, something went wrong...</span>
        </template>
    </base-content>
</template>

<script>
import BaseContent from '../../components/layout/BaseContent'

export default {
  components: {
    BaseContent,
  },
}
</script>
